import React from 'react';
import { Helmet } from 'react-helmet';
import { connect, MapStateToProps } from 'react-redux';
import { navigate, RouteComponentProps } from '@reach/router';

import { RootState } from 'store/store';

import messages from './Messages';
import ChatBody from './ChatBody';
import ChatsList from './ChatsList';
import { Directs, DirectBody } from './styles';
import { IThisUserState } from 'store/thisUser/thisUserSlice';
import { ICompanyState } from 'store/companies/companiesTypes';

interface IStateToProps {
  thisUser: IThisUserState;
  companies: ICompanyState;
}

interface IOwnProps {
  chatId?: string;
  companyId?: string;
}

type IComponentProps = IOwnProps & IStateToProps & RouteComponentProps;

class DirectMessages extends React.PureComponent<IComponentProps> {
  handleSelectChat = (conversationId: number) => {
    navigate(`/t/${this.props.companyId}/messages/${conversationId}`);
  };

  render() {
    const { chatId, companyId } = this.props;
    const selectedChat = chatId ? Number(chatId) : null;
    return (
      <React.Fragment>
        <Helmet>
          <title>{messages.directs}</title>
          <meta name="description" content={messages.directs} />
        </Helmet>
        <Directs>
          <DirectBody>
            <ChatsList
              companyId={Number(companyId)}
              onSelectChat={this.handleSelectChat}
              selectedChat={selectedChat}
            />
            <ChatBody selectedChat={selectedChat} />
          </DirectBody>
        </Directs>
      </React.Fragment>
    );
  }
}

const mapStateToProps: MapStateToProps<
  IStateToProps,
  RouteComponentProps,
  RootState
> = (state: RootState) => {
  const companies = state.companies;
  const thisUser = state.thisUser;

  return { companies, thisUser };
};

export default connect(mapStateToProps)(DirectMessages);
